module.exports = __webpack_public_path__ + "static/media/hanging-mob.e331a3f1.png";